import { Box, Card, Divider } from "@material-ui/core";
import { Button } from "..";
import useStyles from "./service-unavailable-page-styles";

const LyfegenLogo = () => (
	<svg width="120" height="75" viewBox="0 0 120 75" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M60 12.262h60v12.262H72.414C65.558 24.524 60 19.034 60 12.262zM0 0h47.586C54.442 0 60 5.49 60 12.262H0V0zM17.414 68.316v-4.257H8.923V46.307H4.07v22.009h13.343zM27.409 59.487l-1.245 4.793h-.192l-1.213-4.793-2.457-7.725h-4.693l5.874 17.405-.575 1.829h-3.16v3.626h2.937c2.873 0 4.277-1.198 5.139-3.752l6.448-19.108h-4.405l-2.458 7.725zM37.72 68.316h4.724V55.388h3.352v-3.626h-3.352V48.61h3.352v-3.626h-3.064c-3.256 0-5.012 1.64-5.012 4.824v1.955h-2.362v3.626h2.362v12.928zM55.29 68.694c3.065 0 5.523-1.04 7.023-2.743L59.95 63.05c-1.054 1.072-2.14 1.986-4.118 1.986-2.522 0-3.703-1.387-3.703-3.563v-.252h10.757v-1.387c0-4.477-2.234-8.45-7.788-8.45-5.044 0-7.853 3.405-7.853 8.64 0 5.296 2.905 8.67 8.044 8.67zm-.096-13.873c1.884 0 2.81 1.355 2.81 3.373v.284H52.13v-.252c0-2.05 1.181-3.405 3.064-3.405zM81.738 69.514c0-3.059-1.756-4.824-5.842-4.824h-4.852c-1.436 0-2.011-.473-2.011-1.262 0-.567.287-1.04.734-1.324.862.22 1.852.347 2.969.347 4.852 0 7.182-2.176 7.182-5.486 0-2.113-.926-3.816-2.873-4.73v-.189h3.703v-3.468h-2.65c-1.596 0-2.521.756-2.521 2.49v.631c-.83-.22-1.788-.315-2.841-.315-4.82 0-7.183 2.239-7.183 5.58 0 2.145.99 3.816 3.001 4.73v.126c-1.564.316-3.128 1.199-3.128 2.933 0 1.418.83 2.617 2.426 2.9V68c-1.947.252-3.128 1.325-3.128 3.153 0 2.397 2.138 3.847 7.948 3.847 6.831 0 9.066-1.986 9.066-5.486zm-4.438.63c0 1.198-.957 1.766-3.51 1.766h-1.916c-2.554 0-3.511-.567-3.511-1.766 0-.504.191-1.072.606-1.482h5.746c1.883 0 2.585.536 2.585 1.482zm-4.564-10.752c-1.852 0-2.777-.82-2.777-2.27v-.378c0-1.45.925-2.27 2.777-2.27 1.851 0 2.777.82 2.777 2.27v.378c0 1.45-.926 2.27-2.777 2.27zM90.64 68.694c3.065 0 5.523-1.04 7.023-2.743l-2.362-2.901c-1.054 1.072-2.139 1.986-4.118 1.986-2.522 0-3.703-1.387-3.703-3.563v-.252h10.758v-1.387c0-4.477-2.235-8.45-7.79-8.45-5.043 0-7.852 3.405-7.852 8.64 0 5.296 2.905 8.67 8.044 8.67zm-.095-13.873c1.883 0 2.809 1.355 2.809 3.373v.284H87.48v-.252c0-2.05 1.181-3.405 3.065-3.405zM106.298 68.316v-10.72c0-1.64 1.501-2.428 3.033-2.428 1.724 0 2.33 1.04 2.33 3.153v9.995h4.725V57.942c0-4.162-1.82-6.558-5.236-6.558-2.649 0-4.054 1.45-4.66 3.184h-.192v-2.806h-4.724v16.554h4.724z"
			fill="#212121"
		/>
	</svg>
);

interface ServiceUnavailablePageProps {
	statusCode?: string;
	header: string;
	description: string;
	buttonText?: string;
	buttonAction?: () => void;
}

const ServiceUnavailablePage: React.FC<ServiceUnavailablePageProps> = ({statusCode, header, description, buttonText, buttonAction}) => {
	const classes = useStyles();

	return (
		<Box style={{ display: "flex", justifyContent: "center", marginTop: "20vh"}}>
			<Card className={classes.dialog}>
				<Box className={classes.logo}>
					<LyfegenLogo />
				</Box>

				<Divider className={classes.divider} />

				<Box className={classes.codeAndHeaderBox}>
					{statusCode && <span className={classes.statusCode}>{statusCode}</span>}
					<span className={classes.header}>{header}</span>
				</Box>

				<Box className={classes.banner}>
					<span className={classes.description}>
						{description}
					</span>
				</Box>

				{
					buttonText && buttonAction &&
						<Box className={classes.buttonBox}>
							<Button variant="contained" color="primary" className={classes.button} onClick={buttonAction}>
								<span className={classes.buttonText}>{buttonText}</span>
							</Button>
						</Box>
				}
			</Card>
		</Box>
	);
};

export default ServiceUnavailablePage;
